// extracted by mini-css-extract-plugin
export default {"book-title":"book-title__GA4BU","author-name":"author-name__NgNaZ"};